const ButtonBlue = ({ clickAction, label }) => {
    return (
        <div className="rounded py-3 px-5 bg-blue mb-2 flex justify-center cursor-pointer" onClick={clickAction}>
            <p className="urbane-medium whitespace-nowrap text-white">{label}</p>
        </div>
    )
}

export default ButtonBlue